import { render, staticRenderFns } from "./theme-inspector.vue?vue&type=template&id=2ed47d56&scoped=true&"
import script from "./theme-inspector.vue?vue&type=script&lang=ts&"
export * from "./theme-inspector.vue?vue&type=script&lang=ts&"
import style0 from "./theme-inspector.vue?vue&type=style&index=0&id=2ed47d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed47d56",
  null
  
)

export default component.exports